import { useEffect, useState } from 'react'
import { getPriceInfo } from '../../api/payment-methods-pricing-api'
import PriceInfoUI from './UI'
import { translator } from '../../internal/Text'
import {
  getBestMatch,
  getDefaultForCountry,
} from '@merchant-portal/mp-models/lib/locale/languages'
import { getCountryFromLanguage } from '../../models/countries'
import moment from 'moment'
import 'moment/locale/sv'
import 'moment/locale/fi'
import 'moment/locale/da'
import 'moment/locale/nb'

const QueryParams = {
  STORE_ID: 'storeId',
  PAYMENT_METHOD_ID: 'paymentMethodId',
  CHANNEL_TYPE: 'channelType',
  AMOUNT: 'amount',
}

const DefaultChannelType = 'ECOMMERCE'

const PriceInfo = () => {
  const [amount, setAmount] = useState(null)
  const [request, setRequest] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [priceInfo, setPriceInfo] = useState(null)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    setRequest({
      storeId: params.get(QueryParams.STORE_ID),
      paymentMethodId: params.get(QueryParams.PAYMENT_METHOD_ID),
      channelType: params.get(QueryParams.CHANNEL_TYPE) || DefaultChannelType,
      amount: params.get(QueryParams.AMOUNT),
    })
    const langCode = params.get('lang')
    if (langCode) {
      const language = getBestMatch(langCode)
      setLocale({
        country: getCountryFromLanguage(language),
        language,
      })
    }
  }, [])

  useEffect(() => {
    if (
      !!request &&
      Object.values(request).length &&
      Object.values(request).every(
        value => value !== undefined && value !== null,
      )
    ) {
      setAmount(null)
      setIsLoading(true)
      getPriceInfo(request)
        .then(data => {
          setPriceInfo(data)
          setLocale({
            country: data.country,
            language:
              (getLocale() && getLocale().language) ||
              getDefaultForCountry(data.country),
          })
        })
        .catch(() => {
          setPriceInfo(null)
        })
        .finally(() => setIsLoading(false))
    }
  }, [request])

  const setLocale = locale => {
    localStorage.setItem('locale', JSON.stringify(locale))
    translator.setLanguage(locale.language)
    moment.locale(locale.language)
  }

  const handleSubmitAmount = () => {
    setRequest({ ...request, amount })

    const params = new URLSearchParams(window.location.search)
    params.set(QueryParams.AMOUNT, amount)
    window.location.search = params
  }

  return (
    <PriceInfoUI
      amount={amount}
      priceInfo={priceInfo}
      isLoading={isLoading}
      onAmountChange={setAmount}
      onAmountSubmit={handleSubmitAmount}
    />
  )
}

export const getLocale = () => JSON.parse(localStorage.getItem('locale'))

export default PriceInfo
